import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Landing from "@/pages/Landing";
import Staff from "@/pages/Staff";

function App() {
  return (
    <div className="App">
      <Toaster position="bottom-right" />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/staff" element={<Staff />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
